<template>
  <div class="post-content">
    <div class="row row--flex">
      <div class="col-70">
        <p>
          Ten poradnik powstał z zacięcia graniczącego z desperacją. Szukając
          bardziej zrównoważonych rozwiązań drukarskich natrafiałam na
          marketingowe zapewnienia o ekologicznych produktach i maszynach w
          duchu „postaw na ekologię!”, serenadę drukarską „pani, tak się nie da”
          oraz litanie pseudoekologicznych ciekawostek, oddalających projektanta
          czy zleceniodawcę od prostych, nieprzegadanych rozwiązań. Po zebraniu
          materiałów i ich konsultacji z ekspertami przekazuję tutaj
          skondensowaną pigułkę swojej wiedzy. Liczę na to, że ten projekt
          będzie się rozrastał – chociażby o informacje o zrównoważonych
          opakowaniach czy etykietach. Nie jest to publikacj w formie wzornika
          na papierze z tofu z domieszką rzeżuchy, ale liczę na to, że przyda Ci
          się w pracy. To nie jest skończony, zamknięty projekt. Jeśli masz
          pytania lub sugestie – napisz do mnie. Podziel się tym materiałem,
          przekaż go dalej. Jeśli masz ochotę, podziel się swoimi wydrukami i
          doświadczeniami, a my z przyjemnością je opublikujemy.
        </p>
      </div>
      <Sidenote class="col-30">
        <p>
          Najprostsza rzecz do zapamiętania z tego materiału to: hej, nie drukuj
          na foliowanej kredzie! (tak jak teraz jest)
        </p>
      </Sidenote>
    </div>
    <div class="row row--flex">
      <div class="col-70">
        <p>
          Być może niektóre informacje były dla Ciebie zaskakujące. Może teraz
          dłużej zastanowisz się, czy wydruk, który trzymasz w ręku należy
          wyrzucić do pojemnika na papier, czy też jest on zwykłym śmieciem.
          Chciałabym to uprościć. Obecnie nie istnieją jednoznaczne piktogramy,
          które pomogłyby w segregowaniu śmieci. Dlatego przygotowaliśmy własne,
          przejrzyste informacje, z czego składa się dana produkcja. Zachęcam
          Cię też do stosowania ikonek certyfikatów papierów na swoich
          publikacjach czy opakowaniach. Takie rozwiązania są już bardzo
          popularne w Europie Zachodniej, gdzie opakowania w większości nie są
          już lakierowane ani foliowane, a za to na znajduje się na nich wyraźna
          informacja o użytym papierze. Bądźmy świadomi.
        </p>
      </div>
    </div>
    <div class="row row--flex">
      <div class="col-70">
        <p class="indend-left highlighted-text">
          ps. Najprostsza rzecz do zapamiętania z tego materiału to: hej, nie
          drukuj na foliowanej kredzie!
        </p>
      </div>
    </div>
    <div class="row row--flex">
      <div class="col-70">
        <h2 style="margin-bottom: 35px; margin-top: 0">Nasze piktogramy</h2>
        <p>
          Przygotowaliśmy zestaw ikon, które pomogą w komunikacji Twoich druków.
          Możesz używać ich w swoich produkcjach. Pełen zestaw (w wersji
          polskiej i angielskiej) w formacie EPS i PNG możesz pobrać
          <a
            href="https://bit.ly/30dvLMi"
            rel="noopener noreferrer"
            target="_blank"
            class="highlighted-text"
            >tutaj</a
          >.
        </p>
      </div>
    </div>
    <div class="row row--flex">
      <div class="col-70">
        <h2 style="margin-bottom: 35px; margin-top: 0; font-weight: 700">
          Sprawdź zanim zlecisz
        </h2>
        <p class="heading--sans-serif">Lista kontrolna przed produkcją</p>
        <ul>
          <li>Czy naprawdę potrzebuję tej produkcji?</li>
          <li>
            Czy wiem, jak będzie wyglądać dystrybucja tego druku i ile będzie
            trwała?
          </li>
          <li>
            Czy wiem, skąd pochodzi papier, na który się zdecydowałem/am? (jak
            się nazywa, kto jest jego producentem, jakie ma certyfikaty)
          </li>
          <li>
            Czy zrezygnowałem/am z papieru kredowego na rzecz niepowlekanego?
          </li>
          <li>
            Czy uszlachetnienia, które wybrałem/am nie wpłyną na możliwość
            utylizacji mojej produkcji?
          </li>
          <li>
            Czy poinformowałem/am mojego odbiorcę o tym, z czego składa się moja
            produkcja i jak ją mogę zutylizować?
          </li>
          <li>Czy wybrałem/am drukarnię lokalną?</li>
          <li>
            Czy zadbałem/am o to, by przesyłka nie zawierała zbędnej folii /
            plastiku?
          </li>
        </ul>
      </div>
    </div>
    <div class="row row--flex">
      <div class="col-70">
        <h2 style="margin-bottom: 35px; margin-top: 0; font-weight: 700">
          Sprawdź zanim zlecisz
        </h2>
        <p class="heading--sans-serif">Drukuję!</p>
        <img
          v-lazy="require('@/assets/img/przedruk-schemat-01.svg')"
          alt
          class="schema"
        />
      </div>
      <div class="col-30">
        <RelatedPosts :currentPostID="postID" />
      </div>
    </div>

    <ScrollToTop />
  </div>
</template>

<script>
import RelatedPosts from "../RelatedPosts";
import ScrollToTop from "../ScrollToTop";
import Sidenote from "../Sidenote";

export default {
  name: "Post6",
  components: {
    RelatedPosts,
    ScrollToTop,
    Sidenote,
  },
  props: {
    postID: Number,
  },
};
</script>

<style lang="scss">
.schema {
  max-width: 100%;
}
</style>